import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./prop1side.css";
import { Modal } from "react-bootstrap";
import Premiumbreakup from "../../RolloverBike/Premiumbreakup";
function Prop1side() {
  const QuickQuotes = useSelector((state) => state?.vehicledetail?.quickquotes);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  // console.log(QuickQuotes);
  const [Quote, setQuote] = useState(QuickQuotes);
  const [loading, setLoading] = useState(false);
  const state = useSelector((store) => store.addressdetail.choice);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (state) {
      setLoading(true);
    }
  }, []);

  const handlePremium = () => {
    setShow(true);
  };
  return loading ? (
    <div>
      <h1>Loading....</h1>
    </div>
  ) : (
    <>
      <div className="prop1parent-skb">
        <div className="prop1parent-skb-child">
          <div>
            <img src={SelectedQQ?.logo} alt=""></img>
          </div>
          <div>
            <span style={{ padding: "0px 10px 0px" }}>
              Vehicle No:
              {SelectedQQ?.vehicle?.licensePlateNumber}
            </span>{" "}
            <br />
            <span style={{ padding: "0px 10px 0px" }}>
              {SelectedQQ?.vehicle?.make} {SelectedQQ?.vehicle?.model}
            </span>
          </div>
        </div>

        <div className="prop1parent-skb-child">
          <div>
            <p>IDV:{SelectedQQ?.vehicle?.vehicleIDV?.ex_showroom_price}</p>
            <p>
              NCB:
              {SelectedQQ?.previousInsurer?.previousNoClaimBonus === "TWENTY"
                ? "25%"
                : SelectedQQ?.contract?.currentNoClaimBonus}
            </p>
          </div>
          <div className="prop1parent-skb-child-grey">
            <p style={{ background: "#F5F5F5" }}>Zero Deprecation : N/A</p>
          </div>
        </div>

        <div className="prop1parent-skb-child">
          <div className="proptotalprempay">
            <p>Total Premium Payable</p>
            <p
              style={{
                color: "#686868;",
                fontSize: "20px",
                fontWeight: "bolder",
              }}
            >
              ₹{" "}
              {typeof SelectedQQ?.grossPremium === "string"
                ? Math.round(
                    parseFloat(SelectedQQ?.grossPremium.replace(/[^\d.]/g, ""))
                  )
                : SelectedQQ?.grossPremium}
            </p>
            <p
              style={{ color: "blue", cursor: "pointer" }}
              onClick={handlePremium}
            >
              Premium Breakup
            </p>
          </div>
          <div>
            <p style={{ background: "#F5F5F5" }}>Working policy</p>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
      >
        <Premiumbreakup
          quickQuote={SelectedQQ}
          Addon={SelectedQQ?.coverages?.addons}
        />
      </Modal>
    </>
  );
}

export { Prop1side };
